import React from 'react'

import { Banner, DashboardLE2022, StepByStepLE2022, DashboardLE2023, StepByStepLE2023, DashboardLE2024, StepByStepLE2024 } from 'election-stats-icu'
import 'election-stats-icu/dist/index.css'

const App = (props) => {
  const settings = {
    ...props.settings,
    votingClaseDate: new Date(props.settings.votingCloseDate)
  }

  switch (props.app) {
    case 'DashboardLE2024':
      return <DashboardLE2024 {...settings} />
    case 'StepByStepLE2024':
      return <StepByStepLE2024 {...settings} />
    case 'DashboardLE2023':
      return <DashboardLE2023 {...settings} />
    case 'StepByStepLE2023':
      return <StepByStepLE2023 {...settings} />
    case 'DashboardLE2022':
      return <DashboardLE2022 {...settings} />
    case 'StepByStepLE2022':
      return <StepByStepLE2022 {...settings} />
    case 'Banner':
    default:
      return <Banner {...settings} />
  }
}

export default App
